import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { FaBars, FaTimes, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
  const [moreDropdownOpen, setMoreDropdownOpen] = useState(false);

  // Mobile dropdowns
  const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
  const [mobileMoreOpen, setMobileMoreOpen] = useState(false);

  const toggleMenu = () => {
    if (window.innerWidth < 992) {
      setMenuOpen(prev => !prev);
    }
  };

  const closeMenu = () => {
    if (menuOpen) {
      setMenuOpen(false);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" onClick={closeMenu}>
          <img
            className="logo"
            src={'/static/media/footer_logo.1cc7a3750246f8e90b27.png'}
            alt="Alutuff ACP sheets logo"
            width="140"
            height="45"
          />
        </Link>

        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>

          <li
            className="dropdown"
            onMouseEnter={() => setAboutDropdownOpen(true)}
            onMouseLeave={() => setAboutDropdownOpen(false)}
          >
            <span className="dropdown-toggle">About</span>
            <ul className={`dropdown-menu ${aboutDropdownOpen ? 'show' : ''}`}>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/established">Established Excellence</Link></li>
            </ul>
          </li>

          <li><Link to="/products">Products</Link></li>
          <li><Link to="/projects">Projects</Link></li>
          <li><Link to="/career">Careers</Link></li>

          <li
            className="dropdown"
            onMouseEnter={() => setMoreDropdownOpen(true)}
            onMouseLeave={() => setMoreDropdownOpen(false)}
          >
            <span className="dropdown-toggle">More</span>
            <ul className={`dropdown-menu ${moreDropdownOpen ? 'show' : ''}`}>
              <li><Link to="/catalogues">Catalogues</Link></li>
              <li><Link to="/news">News & Events</Link></li>
              <li><Link to="/test-report">Test Reports</Link></li>
              <li><Link to="/certificates">Certificates</Link></li>
              <li><Link to="/blog">Blogs</Link></li>
            </ul>
          </li>

          <li><Link to="/contact">Contact Us</Link></li>
          {/* Desktop Become A Dealer Button */}
          <li>
            <Link to="/dealer" className="dealer-btn desktop-only">Become A Dealer</Link>
          </li>
        </ul>

        <div className="hamburger" onClick={toggleMenu} aria-label="Toggle navigation menu">
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>

      <div className={`side-menu ${menuOpen ? 'open' : ''}`}>
        <div className="side-menu-header">
          <Link to="/" onClick={toggleMenu}>
            <img
              className="side-logo"
              src={'/static/media/footer_logo.1cc7a3750246f8e90b27.png'}
              alt="Alutuff ACP sheets logo"
              width="140"
              height="45"
            />
          </Link>
        </div>

        <ul className="side-nav-links">
          <li><Link to="/" onClick={toggleMenu}>Home</Link></li>

          {/* Mobile About Dropdown */}
          <li className="side-dropdown">
            <span
              className="side-about-title"
              onClick={() => setMobileAboutOpen(!mobileAboutOpen)}
            >
              About {mobileAboutOpen ? <FaChevronUp /> : <FaChevronDown />}
            </span>
            {mobileAboutOpen && (
              <ul className="side-dropdown-menu">
                <li><Link to="/about" onClick={toggleMenu}>About Us</Link></li>
                <li><Link to="/established" onClick={toggleMenu}>Established Excellence</Link></li>
              </ul>
            )}
          </li>

          <li><Link to="/products" onClick={toggleMenu}>Products</Link></li>
          <li><Link to="/projects" onClick={toggleMenu}>Projects</Link></li>
          <li><Link to="/career" onClick={toggleMenu}>Careers</Link></li>

          {/* Mobile More Dropdown */}
          <li className="side-dropdown">
            <span
              className="side-about-title"
              onClick={() => setMobileMoreOpen(!mobileMoreOpen)}
            >
              More {mobileMoreOpen ? <FaChevronUp /> : <FaChevronDown />}
            </span>
            {mobileMoreOpen && (
              <ul className="side-dropdown-menu">
                <li><Link to="/catalogues" onClick={toggleMenu}>Catalogues</Link></li>
                <li><Link to="/news" onClick={toggleMenu}>News & Events</Link></li>
                <li><Link to="/test-report" onClick={toggleMenu}>Test Reports</Link></li>
                <li><Link to="/certificates" onClick={toggleMenu}>Certificates</Link></li>
                <li><Link to="/blog" onClick={toggleMenu}>Blogs</Link></li>
              </ul>
            )}
          </li>

          <li><Link to="/contact" onClick={toggleMenu}>Contact Us</Link></li>
          {/* Mobile Become A Dealer Link */}
          <li><Link to="/dealer" onClick={toggleMenu}>Become A Dealer</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
